import { Alert, AlertProps, Box, alpha, styled } from "@mui/material";

const getSeverityStyles = (
  severity: "info" | "warning" | "error" | "success",
  theme: any
) => {
  const colors = {
    info: {
      color: theme.palette.info.dark,
      backgroundColor: alpha(theme.palette.info.main, 0.08),
      codeBackgroundColor: alpha(theme.palette.info.main, 0.32),
    },
    warning: {
      color: theme.palette.warning.dark,
      backgroundColor: alpha(theme.palette.warning.main, 0.08),
      codeBackgroundColor: alpha(theme.palette.warning.main, 0.32),
    },
    error: {
      color: theme.palette.error.dark,
      backgroundColor: alpha(theme.palette.error.main, 0.08),
      codeBackgroundColor: alpha(theme.palette.error.main, 0.32),
    },
    success: {
      color: theme.palette.success.dark,
      backgroundColor: alpha(theme.palette.success.main, 0.08),
      codeBackgroundColor: alpha(theme.palette.success.main, 0.32),
    },
  };

  return colors[severity];
};

export const CommonWrap = styled(Box)(({ theme }) => ({
  ".title": {
    color: theme.palette.text.primary,
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "12px",
  },

  ".title_0": {
    color: theme.palette.text.primary,
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "12px",
  },

  ".desc": {
    color: theme.palette.text.primary,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: "8px",
    // lineBreak: "anywhere",
    whiteSpace: "pre-line",
  },
  ".code": {
    code: {
      backgroundColor: alpha(theme.palette.grey[500], 0.1),
      padding: "6px 8px",
      borderRadius: "4px",
      color: theme.palette.text.primary,
    },
    ul: {
      marginLeft: "20px",
      marginBottom: "-20px",
    },
  },

  ".title_1": {
    color: theme.palette.text.primary,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    marginBottom: "8px",
  },
  ".info_box": {
    borderRadius: "8px",
    background: alpha(theme.palette.info.main, 0.16),
    display: "flex",
    alignItems: "center",
    padding: "6px 16px",
    i: {
      color: "#00b8d9",
      fontSize: "24px",
    },
  },
  ".info_text": {
    color: theme.palette.info.main,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "22px",
  },
  ".link": {
    color: theme.palette.info.main,
    textDecorationColor: theme.palette.info.main,
  },
  ".mr-1": {
    marginRight: "8px",
  },
}));

export const Mb3Box = styled(Box)(() => ({
  marginBottom: "24px",
}));

export const ComomonAlert = styled((props: AlertProps) => {
  const { severity = "info" } = props;
  return <Alert variant="standard" severity={severity} {...props} />;
})(({ theme, severity = "info" }) => {
  const styles = getSeverityStyles(
    severity as "info" | "warning" | "error" | "success",
    theme
  );

  return {
    color: styles.color,
    backgroundColor: styles.backgroundColor,
    whiteSpace: "pre-line",

    ".info-code": {
      backgroundColor: styles.codeBackgroundColor,
      padding: "2px 4px",
      borderRadius: "2px",
      color: styles.color,
      marginLeft: "2px",
      marginRight: "2px",
    },
  };
});
// export const CommonWrap = styled.div`
//   .title {
//     color: #1f2025;
//     font-family: Poppins;
//     font-size: 24px;
//     font-style: normal;
//     font-weight: 700;
//     line-height: 24px; /* 100% */
//     margin-bottom: 12px;
//   }
//   .desc {
//     color: #3e3f46;
//     font-family: Poppins;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 24px; /* 171.429% */
//     margin-bottom: 8px;
//   }
//   .title_1 {
//     color: #3e3f46;
//     font-family: Poppins;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 600;
//     line-height: 24px; /* 171.429% */
//     margin-bottom: 8px;
//   }
//   .warning_box {
//     border-radius: 8px;
//     background: rgba(0, 184, 217, 0.08);
//     display: flex;
//     align-items: center;
//     padding: 6px 16px;
//     i {
//       color: #00b8d9;
//       font-size: 24px;
//       margin-right: 12px;
//     }
//   }
//   .warning_text {
//     color: #006c9c;
//     font-family: Poppins;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 22px; /* 157.143% */
//   }
//   .link {
//     color: #00b8d9;
//     text-decoration-color: #00b8d9;
//   }
//   .mr-1 {
//     margin-right: 8px;
//   }
// `;
